import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import ViewDetail from "../../Components/EqaroProperty/ViewDetail";
import Table from "../../Components/EqaroProperty/Table";
import UserSetting from "../../Components/EqaroProperty/UserSetting";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
  Button,
} from "../../Components/Styles/PageStyles";

import {
  FieldWrapper,
  InputGroup,
  Label,
  SubmitBtn,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { MdAdd } from "react-icons/md";

const EqaroProperties = ({}) => {
  const { landlordId, clientId, propId ,bondPlan ,isBondAvailable} = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [viewDocument, setViewDocument] = useState(false);
  const [userSetting, setUserSetting] = useState(false);
  const [apiData, setApiData] = useState();
  const [userData, setUserData] = useState();
  const [addCharges, setAddCharges] = useState(null);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1090, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(1090, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("landlordId", landlordId);
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    return await axios.post(`${Config.apiUrl}/eqarogetproperties`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getEqaroPropertiesSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false)
       error = true;
    else setApiData(res.data.data);
  };

  const getEqaroPropertiesError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getEqaroPropertiesMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getEqaroPropertiesSuccess,
    onError: getEqaroPropertiesError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getEqaroPropertiesMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getEqaroPropertiesMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };


  
  const userSettingFunction = async (values) => {
    const body = new FormData();
    body.append("propId", values.propId);
    body.append("clientId", values.clientId);
    body.append("bondPlan", values.bondPlan);
    body.append("isBondAvailable", values.isBondAvailable);
    return await axios.post(`${Config.apiUrl}/editeqaropropdetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const userSettingSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Select successful!");
      setUserData(data.data);
    }
    getEqaroPropertiesMutate();
    setSelectedData("");
    setUserSetting(false);
    
  };

  const userSettingError = (error) => {
    setUserSetting(false);
    setSelectedData("");
    toast.error(
      error.response.data.errors.message ||
        "An Error occured during  Selecting on User Setting"
    );
  };

  const { isLoading: userSettingLoading, mutate: userSettingMutate } =
    useMutation(userSettingFunction, {
      onSuccess: userSettingSuccess,
      onError: userSettingError,
    });

  // const submitHandler = (values) => {
  //   const newValues = {
  //     startDate: moment(values.startDate).format("YYYY-MM-DD"),
  //     endDate: moment(values.endDate).format("YYYY-MM-DD"),
  //   };
  //   setStartDate(newValues.startDate);
  //   setEndDate(newValues.endDate);
  // };
  // const ChangeHandler = (e) => {
  //   setFilterValue(e.target.value);
  // };
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Eqaro Properties")}
                {/* <span>/{location?.state?.name}</span> */}
              </Title>
              <Underline />
            </div>

            <UploadWrapper>
              <Button
                type="button"
                onClick={() => {
                  navigate(`/eqaroPropertyForm/${clientId}`);
                }}
              >
                <MdAdd className="text-white w-5 h-5" />
                <p className="text-sm ml-2">Add Property</p>
              </Button>
            </UploadWrapper>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              t={t}
            />
          </div>

          {viewDetail && (
            <ViewDetail
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

            {userSetting && (
            <UserSetting
              setUserSetting={setUserSetting}
              selectedData={selectedData}
              userSettingMutate={userSettingMutate}
              userSettingLoading={userSettingLoading}
            
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              {apiData?.length > 0 ? (
                <Table
                  ApiData={apiData}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  setEditUser={setEditUser}
                  setViewDetail={setViewDetail}
                  setUserSetting={setUserSetting}
                  setViewDocument={setViewDocument}
                  userType={user.userType}
                />
              ) : (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");

  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  className="ml-1 border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? ( // Render dropdown for "Status"
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="1">{t("Pending")}</MenuItem>
                  <MenuItem value="2">{t("Completed")}</MenuItem>
                  <MenuItem value="3">{t("Active")}</MenuItem>
                  <MenuItem value="4">{t("Inactive")}</MenuItem>
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  const selectedFilter = e.target.value;
                  setFilter(selectedFilter);

                  // Prefill "KIPN" for "GId" filter
                  if (selectedFilter === "gId") {
                    setFilterValue("KIPN");
                  } else {
                    setFilterValue(""); // Clear for other filters
                  }
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ t }) => {
  return <UploadWrapper></UploadWrapper>;
};
const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default EqaroProperties;
